var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 365,
    viewBox: "0 0 1512 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1352.54 122.458L1319.92 117.774C1194.42 99.6461 1064.67 80.9114 946.059 108.586C875.29 125.098 816.653 156.87 759.963 187.6C713.103 213.01 664.62 239.29 609.103 257.168C498.117 292.928 364.944 292.63 261.319 288.38C234.974 287.306 208.285 285.902 182.407 284.547C91.893 279.817 -1.69378 274.875 -92.7073 283.005C-96.8349 283.36 -100.9 283.767 -105.013 284.169L-113 283.541C-106.528 282.81 -99.871 282.124 -93.0361 281.512C-1.77894 273.371 91.9535 278.309 182.611 283.051C208.465 284.404 235.177 285.81 261.519 286.899C364.835 291.124 497.571 291.433 608.186 255.84C663.42 238.046 711.793 211.833 758.57 186.478C815.445 155.671 874.198 123.802 945.397 107.188C1064.5 79.3405 1194.63 98.135 1320.44 116.349C1331.39 117.936 1342.27 119.497 1353.07 121.032C1402.73 128.069 1457.59 134.441 1512.78 136.257L1512.48 137.746C1457.18 135.875 1402.27 129.5 1352.54 122.458Z",
    fill: "#BEF0ED"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2501_15787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.877 321.472C296.959 353.256 446.808 323.251 548.557 292.445C600.925 276.615 651.927 257.815 701.251 239.638C765.111 216.107 831.16 191.793 900.624 173.686C968.409 156.025 1140.45 120.897 1273.26 175.856C1349.6 207.48 1402.68 265.819 1431.01 349.254C1433.66 357.098 1436.08 365.048 1438.41 372.999L1441.25 372.999C1438.89 364.924 1436.45 356.867 1433.74 348.881C1405.3 264.983 1351.77 206.271 1274.76 174.38C1140.87 118.941 967.754 154.282 899.543 172.05C829.909 190.192 763.774 214.541 699.857 238.108C650.561 256.268 599.616 275.032 547.362 290.844C446.097 321.49 297.044 351.317 161.901 319.818C113.743 308.559 69.795 289.99 27.3262 272.026C9.63328 264.538 -8.31567 256.979 -26.7197 249.882L-26.7197 251.963C-8.91302 258.882 8.46702 266.192 25.6764 273.503C68.3158 291.52 112.377 310.16 160.877 321.472Z",
    fill: "#5ED9D1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2501_15787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1467.89,
    height: 228.517,
    fill: "white",
    transform: "translate(-26.6921 144.481)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.2b69de1d0f52e31ccf5c03856bfc30f1.svg";
export { ForwardRef as ReactComponent };